import React from "react";
import { compose } from "redux";
import { connect } from 'react-redux';
import { Field, reduxForm } from "redux-form";
import { MenuItem } from "@material-ui/core";
import { FormResetButton, FormTextField } from "../../../../components";

const formName = 'auctionSummaryReportSalesRepFilter';

const SalesRepFilter = ({ allReps, values, change }) => <>
  <Field
    component={FormTextField}
    name="sales_reps"
    label="Reps"
    select
    style={{minWidth: '100px', marginLeft: 100}}
    inputProps={{multiple: true}}
  >
    {allReps.map((item, i) => (
      <MenuItem value={item} key={i}>{item}</MenuItem>
    ))}
  </Field>

  <Field
    component={FormTextField}
    name="sales_states"
    label="States"
    select
    style={{minWidth: '100px', margin: '0 10px'}}
    inputProps={{multiple: true}}
  >
    <MenuItem value="sold">
      Sold
    </MenuItem>
    <MenuItem value="not_sold">
      Not Sold
    </MenuItem>
    <MenuItem value="pulled">
      Pulled
    </MenuItem>
  </Field>

  {values && (!!values.sales_reps.length || !!values.sales_states.length) && (
    <FormResetButton
      style={{marginTop: 20}}
      onClick={() => {
        change('sales_reps', []);
        change('sales_states', []);
      }}
    />
  )}
</>

const mapStateToProps = state => ({
  values: (state.form[formName] && state.form[formName].values) ? state.form[formName].values : {},
});

export default compose(
  reduxForm({
    form: formName,
    initialValues: {
      sales_reps: [],
      sales_states: [],
    },
  }),
  connect(
    mapStateToProps
  )
)(SalesRepFilter);
